module.exports = __webpack_public_path__ + "static/media/logo_customer360.c7c1ee6d.svg";